import React from "react";
var __jsx = React.createElement;
/** Labeled metadata field showing a muted caption above a value, with "NA" when the value is absent. */
export function LabeledField(_ref) {
  var label = _ref.label,
    value = _ref.value;
  var displayValue = value || "NA";
  var isNA = displayValue === "NA";
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5 w-full min-w-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-caps text-sds-base-tertiary"
  }, label), /*#__PURE__*/React.createElement("span", {
    className: isNA ? "text-style-body-small text-sds-base-tertiary" : "text-style-body-small text-sds-base-default"
  }, displayValue));
}